import React from 'react';
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Header from './header';
import Sidebar from './sidebar';
import * as CommonActions from '../redux/actions/dashboardAction';

const Layout = () => {
  const dispatch = useDispatch();
  const { isSidebarOpen } = useSelector(state => state?.dashboard);

  const handleClickOutside = () => {
    dispatch(CommonActions.setIsSidebarOpne(!isSidebarOpen));
  };

  return (
    <>
      <Header />

      <div style={{ display: "flex" }}>
        <Sidebar />
        <div style={{ flex: 1, height: "100vh", overflowY: "auto" }}>
          <main style={{ padding: "150px 30px 20px 30px", backgroundColor: "#F1F5F9", minHeight: "100vh", color: "#000" }}>
            <Outlet />
          </main>
        </div>
        <div onClick={handleClickOutside} className={`overlay ${isSidebarOpen ? "show" : ""}`}></div>
      </div>

      <Header />
    </>
  );
};

export default Layout;